// Note used at the moment, but might be in the future.
export type State = object

export namespace State {
  /** Initial state for the plugin */
  export const INITIAL: State = {}
}
